import {SkillGroupBaseModel} from '../edu-admin/skillGroupBase.model';
import {QuestionModel} from './question.model';
import {TranslateService} from '@ngx-translate/core';
import {DescriptionModel} from '../shared/description.model';
import {CultureModel} from '../localization-and-pricing/culture.model';


export class QuestionExtendedModel extends QuestionModel {

  skillGroup: SkillGroupBaseModel;

  skillGroupName(): string {

    if (this.skillGroup) {
      return this.skillGroup.name;
    }

    return 'N/A';
  }

  skillGroupIcon() {

    if (this.skillGroup) {
      return this.skillGroup.getCategoryIconURL();
    }

    return null;
  }

  translatedName(culture: string): string {

    if (this.names && culture) {
      return this.names[culture];
    }

    return this.name;

  }

  translatedAnswerType(tSv: TranslateService): string {

    if (!tSv) {
      return '';
    }

    return tSv.instant('answerTypes.' + this.answerType);

  }

  translatedRepresentation(tSv: TranslateService): string {

    if (!tSv) {
      return '';
    }

    return tSv.instant('representationTypes.' + this.representation);

  }

  /**
   * Gives a string to display in the question list view to show the error
   * check.
   */
  adminErrorCheck(): string {

    /**
     * Check if it has all the names required
     */
    if (this.names.hasAllTranslations(CultureModel.list()) === false) {
      return 'Missing title translation';
    }

    if (this.descriptions.hasAllTranslations(CultureModel.list()) === false) {
      return 'Missing question string translation';
    }

    if (!this.skillGroupId) {
      return 'Missing skill group association';
    }

    return '';

  }

}
